<template>
  <div class="support-ticket" @click="onTicketClick(current)">
    <div class="st-meta">
      <div
        class="badge badge-success-inverted"
        v-if="current.etiqueta"
      >{{ current.etiqueta.titulo }}</div>
      <i class="os-icon os-icon-ui-09"></i>
      <div class="status-pill green" v-if="current.estado == 'A'"></div>
      <div class="status-pill red" v-if="current.estado == 'C'"></div>
    </div>
    <div class="st-body">
      <div class="avatar">
        <img v-if="current.usuario_asignado" alt :src="current.usuario_asignado.image" />
      </div>
      <div class="ticket-content">
        <h6 class="ticket-title">{{ current.titulo }}</h6>
        <div
          class="ticket-description"
          v-if="current.descripcion != ''"
        >{{ truncate(current.descripcion, 50) }}</div>
      </div>
    </div>
    <div class="st-foot">
      <span class="label">Creador:</span>
      <a class="value with-avatar" href="#">
        <img v-if="current.usuario_crea" alt :src="current.usuario_crea.image" />
        <span>John Mayers</span>
      </a>
      <span class="label">Creado:</span>
      <span class="value">
        <timeago :datetime="current.fecha_creacion"></timeago>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Object
    }
  },
  mounted() {},
  methods: {
    truncate(text, length, suffix) {
      if (text === undefined || text === null || text == "") {
        return "";
      }
      return text.substring(0, length) + suffix;
    },
    onTicketClick(current) {
      this.$emit("onTicketClick", current);
    },
  }
};
</script>
